import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { useTranslation } from 'react-i18next';
import { copyStringToClipboard, prettifyStars } from '@utils/index';
import InfoBlock from '@components/common/info_block';
import { FC } from 'react';
import { IModalComponentProps } from '@context/modal_context';
import { Icon } from '@components/icons';
import { describeScopes } from '@api';

const ApiKeyInfoModal: FC<
    IModalComponentProps<{ access_key: string; secret_key: string; scopes?: string[] }>
> = ({ modalData }) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_account'
    });
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                API key created
            </Typography>
            <div className={styles.content}>
                <div className={styles.item}>
                    <Typography>Access key</Typography>
                    <div className={styles.row}>
                        <Typography>{modalData?.access_key}</Typography>
                        <Icon
                            name="copy"
                            onClick={() => copyStringToClipboard(modalData?.access_key)}
                        />
                    </div>
                </div>
                <div className={styles.item}>
                    <Typography>Secret key</Typography>
                    <div className={styles.row}>
                        <Typography>{modalData?.secret_key}</Typography>
                        <Icon
                            name="copy"
                            onClick={() => copyStringToClipboard(modalData?.secret_key)}
                        />
                    </div>
                </div>
                <div className={styles.item}>
                    <Typography>Permissions</Typography>
                    <div className={styles.row}>
                        <Typography>{describeScopes(modalData?.scopes)}</Typography>
                    </div>
                </div>
            </div>
            <InfoBlock variant="error">
                Please note: <b>This secret key will only be shown once.</b> Copy and store it
                securely. If you lose it, you’ll need to generate a new one.
            </InfoBlock>
        </div>
    );
};

export default ApiKeyInfoModal;
